import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-renda-estimada-pf',
  templateUrl: './renda-estimada-pf.component.html',
  styleUrls: ['./../cadastral-pf/cadastral-pf.component.css','./renda-estimada-pf.component.css']
})
export class RendaEstimadaPfComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.renda_estimada===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.renda_estimada===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
